interface TrustedTypesLike {
  createPolicy: (
    name: string,
    rules: { createScriptURL: (url: string) => string }
  ) => { createScriptURL: (url: string) => unknown };
}

let cachedPolicy: ReturnType<TrustedTypesLike['createPolicy']> | undefined;

const getPolicy = () => {
  const trustedTypes = (window as unknown as { trustedTypes?: TrustedTypesLike }).trustedTypes;
  if (!trustedTypes) return undefined;

  if (!cachedPolicy) {
    cachedPolicy = trustedTypes.createPolicy('looker-embed', {
      createScriptURL: (url: string) => {
        const { protocol } = new URL(url);
        if (protocol !== 'https:') {
          throw new Error(`Refusing to embed non-https Looker URL: ${url}`);
        }
        return url;
      },
    });
  }

  return cachedPolicy;
};

/**
 * Assigning a raw string to iframe.src is a guarded Trusted Types sink (it
 * can be used for javascript: URL injection). Routes the signed embed URL
 * through a policy that rejects non-https schemes, falling back to a plain
 * string where Trusted Types isn't supported. The host itself is trusted as
 * given since the URL comes from our own authenticated signed-URL endpoint
 * (CSP's frame-src is the actual host allowlist).
 */
export const toTrustedIframeSrc = (url: string): string => {
  const policy = getPolicy();
  return (policy ? policy.createScriptURL(url) : url) as string;
};
